import { Group } from "@mantine/core"
import { AgencyOperationsAdminTalentTabs } from "src/components/agency/operations/administrator/talent/AgencyOperationsAdminTalentTabs"
import { EditAgencyOperationsAdminTalentAction } from "src/components/agency/operations/administrator/talent/AgencyOperationsAdminTalentActions"
import { useAppState } from "src/state"
import { DrawerPageLayout } from "src/components/ui/DrawerPageLayout"
import { DrawerPageHeader } from "src/components/ui/DrawerPageHeader"
import { AgencyOperationsAdminTalentView } from "src/components/agency/operations/administrator/talent/AgencyOperationsAdminTalentView"

export function AgencyOperationsAdminTalentOverlay() {

    const { currentItem } = useAppState(state=>state.users)

    return (
        <DrawerPageLayout
            header={
                <DrawerPageHeader
                    title={`${currentItem?.dj_display}`} 
                    renderAction={ 
                        <Group gap="sm"> 
                            <EditAgencyOperationsAdminTalentAction />
                        </Group>
                    }
                />
            }
        >
            <AgencyOperationsAdminTalentTabs overlay={true}/>
            <AgencyOperationsAdminTalentView/>
        </DrawerPageLayout>
    )

}